import React, { useEffect, useState } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { Box, Center, DrawerOverlay, Icon } from '@chakra-ui/react';
import { Drawer, DrawerContent, Text } from '@chakra-ui/react';
import { DateFilter } from 'components/Filters/DateFilters';
import { SelectFilters } from 'components/Filters/SelectFilters';
import { LoadingModal } from 'components/LoadingModal';
import { filterOptions } from 'pages/Logs/mocks';
import { actionFormatter, sectionFormatter } from 'utils/formaters';

interface FilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
}

export const FilterDrawer: React.FC<FilterDrawerProps> = ({
  isOpen,
  onClose,
  setFilter,
}) => {
  const [actions, setActions] = useState<string[]>([]);
  const [status, setStatus] = useState<string[]>([]);
  const [sections, setSections] = useState<string[]>([]);

  const handleFilter = () => {
    const actionUrl = actions.map(item => `acoes=${actionFormatter(item)}`);
    const statusUrl = status.map(item => `sucesso=${item === 'Sucesso'}`);
    const sectionUrl = sections.map(item => `secoes=${sectionFormatter(item)}`);

    setFilter([...actionUrl, ...statusUrl, ...sectionUrl].join('&'));
  };

  const handleChange = (option: string, title: string, checked: boolean) => {
    switch (title) {
      case 'Ação':
        checked
          ? setActions(action => [...action, option])
          : setActions(action => action.filter(action => option !== action));
        break;
      case 'Status':
        checked ? setStatus([option]) : setStatus([]);
        break;
      case 'Seção acessada':
        checked
          ? setSections(from => [...from, option])
          : setSections(from => from.filter(from => option !== from));
    }
  };

  useEffect(() => {
    handleFilter();
  }, [actions, status, sections]);

  return (
    <Drawer
      closeOnOverlayClick
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      returnFocusOnClose={false}
      onOverlayClick={onClose}
      size="sm"
    >
      <LoadingModal isOpen={false} />
      <DrawerOverlay />
      <DrawerContent bg="grey.200">
        <Center
          data-cy="close-filter"
          onClick={onClose}
          as="button"
          top="68px"
          border="4px solid"
          borderColor="grey.100"
          borderRadius="20px"
          left={-5}
          bg="white"
          position="absolute"
          w="40px"
          h="40px"
        >
          <Icon w="24px" h="8" color="black" as={IoIosArrowForward} />
        </Center>
        <Box
          bg="grey.100"
          sx={{
            '&::-webkit-scrollbar': {
              borderRadius: '8px',
              backgroundColor: 'grey.100',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey.300',
            },
          }}
          overflowX="scroll"
          px="40px"
          pt="74px"
          h="100%"
        >
          <Text fontWeight={500} color="text.100" fontSize="24px" mb="16px">
            Filtrar
          </Text>
          <DateFilter path="/logs" />
          <SelectFilters
            selected={[...actions, ...status, ...sections]}
            handleChange={handleChange}
            selects={filterOptions}
          />
        </Box>
      </DrawerContent>
    </Drawer>
  );
};
